<template>
  <div class="el-collapse-item-content">
    <el-form v-for="(customFieldInfo, index) in customFieldList" :key="index" :model="customFieldInfo" class="printDesignFormField" label-width="90px">
      <el-form-item v-if="!isCustomData" label="字段名称" prop="customizedFieldName">
        <span slot="label" class="lowHeight">字段名称</span>
        <el-button type="text" size="mini" class="underline lowHeight" @click="editCustomField(index)">{{ customFieldInfo.customizedFieldName }}</el-button>
      </el-form-item>
      <el-form-item v-if="!isCustomData" label="显示名称" prop="customizedFieldDisplayName">
        <span slot="label" class="lowHeight">显示名称</span>

        <div class="input noBorder ell lowHeight">{{ customFieldInfo.customizedFieldDisplayName }}</div>
      </el-form-item>
      <el-form-item label="自定义方法">
        <span slot="label" class="lowHeight">自定义方法</span>

        <div class="input noBorder ell lowHeight">{{ customFieldInfo.customizedMethod }}</div>
      </el-form-item>
      <el-form-item label="自定义SQL">
        <span slot="label" class="lowHeight">自定义SQL</span>

        <div class="input noBorder ell lowHeight">{{ customFieldInfo.customizedSql }}</div>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="text" @click="editCustomField(index)">编辑</el-button>
        <el-button v-if="!isCustomData" size="mini" type="text" @click="deleteCustomField(index)">删除</el-button>
        <el-button v-if="!isCustomData" size="mini" type="text" @click="handleCopy(index)">复制当前字段</el-button>
      </el-form-item>
      <el-divider></el-divider>
    </el-form>
    <el-dialog title="编辑" :visible.sync="codeMirrorDialogVisible" width="1000px">
      <el-form ref="dlgForm" :model="curOpareteObj.source" class="" label-width="130px" :rules="rules">
        <el-form-item v-if="!isCustomData" label="字段名称" prop="customizedFieldName">
          <el-input v-model="curOpareteObj.source.customizedFieldName" class="input" placeholder="请输入字段名称" size="mini"></el-input>
        </el-form-item>
        <el-form-item v-if="!isCustomData" label="字段说明" prop="customizedFieldDisplayName">
          <el-input v-model="curOpareteObj.source.customizedFieldDisplayName" class="input" placeholder="请输入显示名称" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="自定义方法">
          <div>
            <el-input v-model="curOpareteObj.source.customizedMethod" class="wideInput" placeholder="请输入自定义方法" size="mini"></el-input>
            <el-popover placement="top-start" title="" width="350" trigger="click">
              <div>说明：请填入 bean 的名称，其中<br />（1）此类必需注入到 spring ioc 容器中<br />（2）必需实现接口：FormPrintingFieldParamDataProvider</div>
              <el-button slot="reference" type="text"><i class="el-icon-question"></i>帮助</el-button>
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item label="自定义SQL">
          <div>
            <codemirror v-model="curOpareteObj.source.customizedSql" class="codemirror" :options="cmOptions"></codemirror>
            <el-popover placement="top-start" title="" width="350" trigger="click">
              <div>
                说明：可通过 sql 查询来获取数据。<br />（1）仅支持 select 查询语句<br />（2）支持输出一个字段和多个字段<br />（3）请按 mybatis 语法使用参数，参数必需是
                #{xxx}，不能是 ${xx} 所有输入参数都可以作为mybatis 的输入参数，但需要带上限定符 p. ，如 p.prj.prjId 可获得项目id
              </div>
              <el-button slot="reference" type="text"><i class="el-icon-question"></i>帮助</el-button>
            </el-popover>
          </div>
          <el-popover placement="top-start" title="" width="350" trigger="click">
            <div>说明：<br />（1）至少填入一项数据来源方式<br />（2）如果同时填写了 自定义方法、自定义SOL，则先执行自定义 SQL</div>
            <el-button slot="reference" type="text"><i class="el-icon-question"></i>填写说明</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item v-if="!isCustomData" label="输出数据类型">
          <el-radio-group v-model="curOpareteObj.source.customDataType">
            <el-radio label="list">列表（数组）</el-radio>
            <el-radio label="object">单一值（对象）</el-radio>
          </el-radio-group>
          <el-popover placement="top-start" title="" width="350" trigger="click">
            <div>
              说明：当选择【单一值（或对象）】时，<br />（1）如果 sql 输出的内容包含多条记录时，只取第1条记录 <br />（2）如果
              sql 输出的只有一个字段，则直接将其值输出，否则输出一个对象
            </div>
            <el-button slot="reference" type="text"><i class="el-icon-question"></i>帮助</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item v-if="!isCustomData" label="关联输出个人签名">
          用户id字段：<el-input v-model="curOpareteObj.source.signUserIdField" class="input" placeholder="请输入用户id字段" size="mini"></el-input>
          <el-popover placement="top-start" title="" width="350" trigger="click">
            <div>
              说明：如果填入了用户id字段，则会尝试从返回的字段中获取对应字段的值，用它查找到对应的个人签名，再以新字段:sign的形式填入新字段。如用户id字段是
              designUserId 则会填入一个新字段 designUserId@sign，其内容是个人签名文件
            </div>
            <el-button slot="reference" type="text"><i class="el-icon-question"></i>帮助</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item v-if="!isCustomData" label="签名图片大小" prop="">
          最大宽度：
          <el-input-number
            v-model="curOpareteObj.source.signMaxWidth"
            :min="0"
            :step="1"
            step-strictly
            class="input"
            placeholder="请输入签名图片宽度（带单位）"
            size="mini"
          ></el-input-number>
          最大高度：
          <el-input-number
            v-model="curOpareteObj.source.signMaxHeight"
            :min="0"
            :step="1"
            step-strictly
            class="input"
            placeholder="请输入签名图片高度（带单位）"
            size="mini"
          ></el-input-number>
          <el-popover placement="top-start" title="" width="200" trigger="click">
            <div>说明：如果为0则不进行缩放</div>
            <el-button slot="reference" type="text"><i class="el-icon-question"></i>帮助</el-button>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" type="" @click="handleCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-button v-if="!isCustomData" slot="reference" size="small" type="text" @click="addCustomField">添加字段</el-button>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/sql/sql.js";
// 替换主题这里需修改名称
import "codemirror/theme/idea.css";
import "codemirror/theme/xq-light.css";
import "codemirror/mode/sql/sql.js";
// 加提示的引用
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/sql-hint";
import "codemirror/addon/hint/show-hint";
function FieldInfo() {
  return {
    customizedFieldName: "",
    customizedFieldDisplayName: "",
    customizedMethod: "",
    customizedSql: "",
    customDataType: "list",
    signUserIdField: "",
    signMaxWidth: 0,
    signMaxHeight: 0
  };
}
export default {
  name: "CustomField",
  components: {
    codemirror
  },
  props: {
    option: {
      type: Object,
      default() {
        return {};
      }
    },
    getAllFieldName: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {
      rules: {
        customizedFieldName: [{ required: true, message: "请填写字段名称", trigger: "blur" }]
        // customizedFieldDisplayName: [{ required: true, message: "请填写显示名称", trigger: "blur" }]
      },
      customFieldList: [],
      curOpareteObj: { source: new FieldInfo(), index: 0 },
      fieldInfo: {},
      sql: "",
      codeMirrorDialogVisible: false,
      cmOptions: {
        tabSize: 4,
        mode: "text/x-sql",
        theme: "xq-light",
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        matchBrackets: true, // 括号匹配
        lineWrapping: true,
        // 加提示
        hintOptions: {
          completeSingle: false
        }
      }
    };
  },
  computed: {
    isCustomData() {
      return this.option.name === "customData";
    }
  },
  // mounted() {
  //   console.log(this.option.children.length);
  // },
  watch: {
    "option.children": {
      handler(val) {
        this.customFieldList = val;
      },
      immediate: true
    }
  },
  methods: {
    addCustomField() {
      this.curOpareteObj = {
        source: new FieldInfo(),
        index: this.customFieldList.length
      };
      this.codeMirrorDialogVisible = true;
    },
    checkDuplication(fieldName) {
      const fieldNameArr = this.getAllFieldName();
      console.log(fieldNameArr);
      return fieldNameArr.indexOf(fieldName) !== -1;
    },
    editCustomField(index) {
      this.fieldInfo = this.customFieldList[index];
      this.curOpareteObj = {
        source: cloneDeep(this.fieldInfo),
        index
      };
      this.codeMirrorDialogVisible = true;
    },

    deleteCustomField(index) {
      this.$confirm("确认删除这个自定义字段吗？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (this.curOpareteObj.index !== undefined && index < this.curOpareteObj.index) {
            this.curOpareteObj.index--;
          }
          this.customFieldList.splice(index, 1);
          this.$message.success("字段已删除");
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleCancel() {
      this.codeMirrorDialogVisible = false;
      this.curOpareteObj = { source: new FieldInfo(), index: 0 };
    },
    handleConfirm() {
      this.$refs.dlgForm.validate((valid) => {
        if (valid) {
          const fieldName = this.curOpareteObj.source.customizedFieldName;
          if (!this.isCustomData && this.curOpareteObj.index === this.customFieldList.length && this.checkDuplication(fieldName)) {
            this.$warn("当前命名和已有字段名重复！请更改");
            return false;
          }
          this.customFieldList.splice(this.curOpareteObj.index, 1, this.curOpareteObj.source);
          this.handleCancel();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    blurInput(index) {
      this.$refs.inputRef[index].blur();
    },
    handleCopy(index) {
      const value = this.customFieldList[index].customizedFieldName;
      if (!value) {
        return this.$warn("当前字段名为空！");
      }
      try {
        document.querySelector("iframe").contentWindow.Asc.editor.pluginMethod_InputText(`{{${value}}}`);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  width: 210px;
}
.wideInput {
  width: calc(100% - 50px);
}
.ell {
  width: 280px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}
.underline {
  text-decoration: underline;
}
.noBorder {
  ::v-deep .el-input__inner {
    border: none;
  }
}
.desc {
  line-height: 20px;
}
::v-deep .el-form-item {
  margin-bottom: 3px;
}
// .lowHeight {
//   line-height: 20px;
//   height: 20px;
// }

.printDesignFormField {
  ::v-deep .el-form-item__label {
    height: 20px;
    line-height: 20px;
  }
  ::v-deep .el-form-item__content {
    height: 20px;
    line-height: 20px;
  }
}
::v-deep .el-form-item__error {
  top: 75% !important;
}
::v-deep .el-divider--horizontal {
  margin: 11px 0;
}
.codemirror {
  width: calc(100% - 50px);
  line-height: 20px;
  display: inline-block;
  border: 1px solid #f1eded;
}
</style>
